'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleUGCPermalink = require('./components/SimpleUGCPermalink');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SimpleUGCPermalink).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/simple-ugc-permalink/index.js
// module id = 512
// module chunks = 4